import { createSelector } from 'reselect';

export const authUserStateSelector = state => state.auth.user;

export const currentUserSelector = createSelector(
  authUserStateSelector,
  (authState) => authState.currentUser
);

export const currentUserInfoSelector = createSelector(
  authUserStateSelector,
  (authState) => (authState.currentUserInfo || {})
);

export const isSessionLoadedSelector = createSelector(
    authUserStateSelector,
    (authState) => (authState.isSessionLoaded)
);

export const isCurrentUserLoggedSelector = createSelector(
  authUserStateSelector,
  (authState) => {
    return authState.currentUser != null;
  }
);


// Admins and moderators see the moderator-mode toggle in the sidebar.
export const canModerateSelector = createSelector(
  authUserStateSelector,
  (authState) => {
    const roles = authState && authState.currentUserRoles;
    return !!roles && (roles.isAdmin === true || roles.isModerator === true);
  }
);

// Moderator powers (the cog, deleting other people's media) apply only while
// the sidebar toggle is on. An owner's own rights never depend on it.
export const moderatorModeSelector = createSelector(
  authUserStateSelector,
  canModerateSelector,
  (authState, canModerate) => canModerate && !!(authState && authState.moderatorMode)
);
